import { AdminApiClient } from '@guiker/prop-rental-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAdminApiClient = useAuthenticatedApiClient(AdminApiClient)
